import { render, staticRenderFns } from "./xjffCheckedRightItem.vue?vue&type=template&id=2074942c&scoped=true"
import script from "./xjffCheckedRightItem.vue?vue&type=script&lang=js"
export * from "./xjffCheckedRightItem.vue?vue&type=script&lang=js"
import style0 from "./xjffCheckedRightItem.vue?vue&type=style&index=0&id=2074942c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2074942c",
  null
  
)

export default component.exports